import { environment } from '@environments';

export class StoreEndpointsConstant {
  static api_url: string = environment.api_url.replace(
    '$customer_subdomain$',
    this.getCustomerSubdomain()
  );

  public static readonly USER_PROFILE: string = `${this.api_url}/userProfile`;
  public static readonly TRANSLATIONS: string = `${this.api_url}/translations`;
  public static readonly LOGIN: string = `${this.api_url}/login`;
  public static readonly DIRECT_LOGIN: string = `${this.api_url}/directLogin`;
  public static readonly VALIDATE_DIRECT_LOGIN = `${this.api_url}/validateDirectLogin`;
  public static readonly LOGOUT: string = `${this.api_url}/logout`;
  public static readonly DEVICE_DETAILS: string = `${this.api_url}/assets/device/{id}`;
  public static readonly LINE_DETAILS: string = `${this.api_url}/assets/line/{id}`;
  public static readonly ORDER_TYPES: string = `${this.api_url}/orderTypes`;
  public static readonly COUNTRIES: string = `${this.api_url}/countries`;
  public static readonly USER_ASSETS: string = `${this.api_url}/assets`;
  public static readonly DEVICE_IDENTIFIER: string = `${this.api_url}/lookup/device`;
  public static readonly UPDATE_PRIMARY_LINE: string = `${this.api_url}/assets/line/{id}/primaryLine`;
  public static readonly ORDER_LIST: string = `${this.api_url}/orders`;
  public static readonly DEVICE_SEARCH: string = `${this.api_url}/search/devices`;
  public static readonly LINE_SEARCH: string = `${this.api_url}/search/lines`;
  public static readonly DASHBOARD_NOTIFICATIONS: string = `${this.api_url}/dashboardNotifications`;
  public static readonly ORDER_NOTIFICATIONS: string = `${this.api_url}/orderNotifications`;
  public static readonly PERSON_SEARCH: string = `${this.api_url}/search/people`;
  public static readonly DEVICES: string = `${this.api_url}/devices`;
  public static readonly PLAN_DETAILS: string = `${this.api_url}/plans`;
  public static readonly FEATURE_DETAILS: string = `${this.api_url}/features`;
  public static readonly ACCESSORIES: string = `${this.api_url}/accessories`;
  public static readonly SHOPPING_CART: string = `${this.api_url}/shoppingCart`;
  public static readonly DELETE_CART_ITEMS: string = `${this.api_url}/shoppingCart/items`;
  public static readonly SHOPPING_CART_CLEAR: string = `${this.api_url}/shoppingCart/clear`;
  public static readonly SHOPPING_CART_PRICE: string = `${this.api_url}/shoppingCart/price`;
  public static readonly SHOPPING_CART_SUMMARY: string = `${this.api_url}/shoppingCart/summary`;
  public static readonly APPROVERS: string = `${this.api_url}/approvers/{id}`;
  public static readonly APPROVERS_SEARCH: string = `${this.api_url}/search/approvers`;
  public static readonly FIELDS: string = `${this.api_url}/fields`;
  public static readonly UPLOAD_FILE: string = `${this.api_url}/fields/{id}/upload`;
  public static readonly FIELDS_REVIEW: string = `${this.api_url}/fields/{id}/review`;
  public static readonly FIELDS_VALIDATE: string = `${this.api_url}/fields/validate`;
  public static readonly FIELDS_REVIEW_VALIDATE: string = `${this.api_url}/fields/{id}/validate`;
  public static readonly ORDERS: string = `${this.api_url}/orders/{id}`;
  public static readonly UPDATE_ORDERS: string = `${this.api_url}/orders`;
  public static readonly SUBMIT_ORDERS: string = `${this.api_url}/orders/{id}/submit`;
  public static readonly WHAT_NEXT_NOTIFICATIONS: string = `${this.api_url}/whatNextNotifications`;
  public static readonly DENIAL_NOTIFICATIONS: string = `${this.api_url}/denialNotifications`;
  public static readonly ORDER_TYPE_SETTINGS: string = `${this.api_url}/orderType/settings`;
  public static readonly BRANDING: string = `${this.api_url}/branding/{id}`;
  public static readonly CUSTOM_FILE: string = `${this.api_url}/orders/{order_id}/file/download/{id}`;
  public static readonly DEVICE_IDENTIFIER_VALIDATE: string = `${this.api_url}/device/validate`;
  public static readonly CLIENT_SETTINGS: string = `${this.api_url}/client/{id}/settings`;
  public static readonly CARRIER_VALIDATION: string = `${this.api_url}/orders/preflight`;
  public static readonly GET_HELP_TEXTS: string = `${this.api_url}/helpText`;
  public static readonly STORAGE_LIST: string = `${this.api_url}/devices/carriers/{carrier_id}/colors/{color_name}/sizes`;
  public static readonly NAME_OVERRIDES_LIST: string = `${this.api_url}/devices/carriers/{carrier_id}/colors/{color_name}/sizes/{size}/options`;
  public static readonly GET_LIABILITY_PROGRESS_STEPPER: string = `${this.api_url}/transferDetails`;
  public static readonly SYSTEM_INFO: string = `${this.api_url}/systemInfo`;
  public static readonly CARRIER_LIST: string = `${this.api_url}/devices/carriers`;
  public static readonly COLORS_LIST: string = `${this.api_url}/devices/carriers/{carrier_id}/colors`;

  static getCustomerSubdomain(): string {
    const url_parts: string[] = window.location.hostname.split('.'); // customer1.localhost -> ["customer1","localhost"]

    // You might want to guard against cases with no subdomain:
    if (url_parts.length < 2) return ''; // or return a default

    return url_parts[0]; // "customer1"
  }
}
